import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractionEnginesRoute } from '../../routing'

export  class ExtractionEnginesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ExtractionEnginesRoute />
          </Fragment>
        )
    }
}
